<template>
  <div class="page">
    <div class="page-container">
      <!--        网站首页-->
      <div class="page-tab">
        <img src="../assets/image/page/icon.png"/>
        <div @click="goHome()" class="page-tab-text">网站首页 >></div>
        <span>新闻动态</span>
      </div>
      <!--        文字标题部分-->
      <div class="page-content">
        <div class="page-title">中国银行青岛市分行——大数据营销专享用户系统</div>
        <div class="page-time">
          <div class="page-line" style="margin-right: 20px"></div>
          2021-01-22 13:53
          <span>编辑：常昊</span>
          <div class="page-line" style="margin-left: 20px"></div>
        </div>
      </div>
      <!--        文字内容部分-->
      <div class="page-product">
        <!--          第一部分-->
        <div class="page-one">
          <div class="pagefive-img-one">
            <img src="../assets/image/page/pagefive-1.png"/>
          </div>
          <div class="page-text">
            当今时代既属于互联网，也属于大数据，伴随科技产品与生活的深度结合，让数据的汇总分析也变的更加高效便捷，这也让越来越多的行业和业务职能领域都可以被准确的量化评估。所以数据，成了无可辩驳的重要的生产因素。而对于银行业来说，这更是一次不可多得的机遇。依托银行系统强大的信息优势，灵活运用数据洞察先机，将是银行业打破互联网平台之争的重要风向。
          </div>
          <div class="page-text">
            在此背景下，极欧科技携手中国银行青岛市分行，率先开发了大数据营销专享用户系统！它具备精准细分、高效识别、渠道整合、多元预测、可视化反馈等强大功能。真正做到了数据智能营销，开启了互联网营销的全新方式！
          </div>
          <div class="pagefive-img-one">
            <img src="../assets/image/page/pagefive-2.png"/>
          </div>
          <div class="product-title">1、产品理念</div>
          <div class="page-text">
            我们以“精准营销”为入口，结合大数据的分析应用，围绕目标用户群体，推广更有针对性的产品或服务，全面提高企业的投入产出比例，减少不必要的成本。
          </div>
          <div class="product-title">2、产品特点</div>
          <div class="page-text">01、多元标签分流：</div>
          <div class="page-text">
            大数据营销比的就是如何正确的解读数据，而标签化则是数据分析体现。一份成功的用户画像往往就取决于企业采用那种标签分类方式。而极欧的大数据用户系统，就应用了多维度的标签分类方式，将用户的年纪、性别、所在地域、消费习惯等等数据详细收录，为企业提供准确的分析结论，方便进行业务与活动推广。
          </div>
          <div class="page-text">02、打造丰富使用场景：</div>
          <div class="page-text">构建场景，已经是近年来产品营销的重点竞争领域，因为人们往往会因为不同的使用场景，而增加对应的产品或服务的需求，例如节日，消费者就会有购买节礼的习惯。而大数据的应用，则可以为企业更准确的分类用户，为搭建使用场景提供合理的参考意见，从而增强用户的对活动或服务的认可程度。在实际应用中，我们就针对地域标签，为银行目标用户推广了更具当地特色的活动内容，激发了用户的参与热情，收获一致好评。</div>
          <div class="page-text">03、实时进度反馈：</div>
          <div class="page-text">大数据专享用户系统平台会实时汇总收集相关数据情况，方便企业随时查看，所有活动推广进度与用户的使用反馈，同样，可在线查询，为企业衡量活动推广效果，提供最准确客观的依据，为下企业布置新的营销策略提供详实的资料。</div>
          <div class="page-text">04、数据纠错体系:</div>
          <div class="page-text">通过技术手段升级平台系统，可以进一步筛选信息来源，避免收集错误数据，而导致的决策失误。更减少了“羊毛党”“刷单”等等恶性操作而导致的损失，更好的保护扩大企业利益。</div>
          <div class="pagefive-img-one">
            <img src="../assets/image/page/pagefive-3.png"/>
          </div>
          <div class="product-title"> 3、应用效果</div>
          <div class="page-text">
            历经多次平台升级，目前通过大数据营销专享用户系统推广的银行业务活动，受到了广大用户的热烈欢迎。平台以“白名单”为标签，向优质目标用户集中推广业务活动，达到较高的用户参与程度，为青岛中行手机银行app以及微信公众平台做到了新用户的增加和优质老用户的维护，并提高了不同平台间的用户流动，培养了用户的使用习惯，为企业打造了业务营销的良性循环。
          </div>
          <div class="page-text">
            天津思奇科技股份有限公司为国家高新技术企业，北京极欧科技有限公司为其子公司，集团公司成立于2012年，公司旨在为银行业、中石化等拥有大批C端用户的传统企业，提供金融科技全产业链综合服务，通过多年积累深耕的行业信息化系统建设经验，为客户提供系统规划、方案实施、部署运维、业务运营、用户管理与广告投放等形态多样的一站式金融科技服务，从前端到后端，全面满足客户数字化转型的需求。
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PageFive",
  methods: {
    goHome() {
      this.$router.push('/')
    }
  }
}
</script>

<style scoped lang="less">
.pagefive-img-one {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 50px;
  img {
    width: 1000px;
    height: 555px;
  }
}

.page {
  width: 100%;
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;

  .page-container {
    margin-bottom: 60px;
    position: relative;
    margin-top: -150px;
    width: 70%;
    background: #FFFFFF;
    padding: 100px 60px 100px 60px;
    box-shadow: 0px 20px 73px 0px rgba(102, 153, 204, 0.2);

    .page-tab {
      padding-top: 20px;
      display: flex;
      flex-direction: row;
      align-items: center;

      img {
        width: 15px;
        height: 20px;
        margin-right: 10px;
      }

      .page-tab-text {
        cursor: pointer;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        line-height: 22px;
      }

      span {
        color: #2368DD;
        margin-left: 10px;
      }
    }

    .page-content {
      display: flex;
      flex-direction: column;
      align-items: center;

      .page-title {
        padding-top: 100px;
        font-size: 30px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #000000;
        opacity: 0.9;
      }

      .page-time {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        margin-top: 45px;
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #666666;

        span {
          margin-left: 40px;
        }

        .page-line {
          width: 20%;
          height: 1px;
          background: #000000;
          opacity: 0.2;
        }
      }

    }
    .page-one {
      padding-top: 100px;
      display: flex;
      flex-direction: column;
    }
    .product-title {
      text-indent: 30px;
      padding-top: 40px;
      font-size: 18px;
      color: #5A5A5A;
      font-family: SourceHanSansCN-Normal;
    }

    .page-product {
      display: flex;
      flex-direction: column;
      align-items: center;
      .page-img {
        margin-top: 50px;
      }

      .page-icon {
        padding-top: 30px;
        display: flex;
        flex-direction: row;
        align-items: center;
        color: #5A5A5A;

        span {
          font-size: 18px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color:#5A5A5A;
          line-height: 20px;
          opacity: 0.8;
        }
      }

      .page-text {
        margin-top: 20px;
        font-size: 14px;
        font-family: SourceHanSansCN-Normal;
        font-weight: 400;
        color: #808080;
        line-height: 28px;
        text-indent: 30px;
        opacity: 0.7;
      }

      .page-title {
        text-indent: 30px;
        margin-top: 25px;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #5A5A5A;
        line-height: 26px;
        //opacity: 0.7;
      }

      .page-two-text {
        margin-top: 25px;
        line-height: 30px;
      }
    }
  }
}

@media (max-width: 1200px) {
  .page {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .pagefive-img-one {
    img {
      width: 333px;
      height: 185px;
    }
  }
  .page {
    .page-container {
      margin-top: -90px;
      padding: 50px 60px 100px 60px;

      .page-img {
        img {
          width: 260px;
          height: 144px;
        }
      }

      .page-content {
        .page-title {
          text-align: center;
          padding-top: 50px;
          font-size: 20px;
        }

        .page-time {
          .page-line {
            width: 0;
            height: 0;
          }
        }
      }
    }
  }
}

</style>
